export const MANAGE_TABS = [
  { path: "/admin/apt", label: "아파트 단지 관리" },
  { path: "/admin/user", label: "계정 관리" },
  { path: "/admin/group", label: "그룹 관리" },
  { path: "/admin/log", label: "로그 페이지" }
]

export const LOCKED_SIZE = "__LOCKED__"
